import React from 'react'
import { Drawer, FormControl, Grid, InputLabel, MenuItem, Select } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
// @ts-ignore
import { EditableSelect } from '../common/EditableComponents'
// @ts-ignore
import { metrcEnvironmentOptions as environmentOptions } from '../../utils/constants'
// @ts-ignore
import { CompliancePage } from '../MfeParcels/CompliancePage'

interface Props {
  employee: any
  onClose: () => void
  onChangeEnv: (event: any) => void
  onChangeFac: (event: any) => void
  onSearch: () => void
  environment: any
  facLicense?: string
  facilities: any[]
  shop: any
}

export const MetrcEmployeeDrawer = ({
  employee,
  onClose,
  onChangeEnv,
  onChangeFac,
  onSearch,
  environment,
  facLicense,
  facilities,
  shop,
}: Props) => {
  return (
    <Drawer open={!!employee} onClose={onClose} anchor="right">
      <Grid style={{ margin: 16, minWidth: 300 }}>
        <Grid container>
          <Grid item sm={10}>
            <EditableSelect
              valueToRender={environment}
              editMode={true}
              value={environment}
              onChange={onChangeEnv}
            >
              {environmentOptions.map((env: any) => {
                return (
                  <MenuItem key={env.value} value={env.value}>
                    {env.label}
                  </MenuItem>
                )
              })}
            </EditableSelect>
          </Grid>
          <Grid
            item
            sm={2}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <SearchIcon style={{ cursor: 'pointer' }} onClick={onSearch} />
          </Grid>
        </Grid>
        <FormControl fullWidth className="margin-bottom-small" style={{ marginTop: 16 }}>
          <InputLabel shrink={!!facLicense}>Facility License</InputLabel>
          <Select value={facLicense} onChange={onChangeFac}>
            {facilities.map((option, index) => {
              return (
                // @ts-ignore
                <MenuItem key={index} value={option.License.Number} sm={10}>
                  {option.License.Number} ({option.Name} | {option.License.LicenseType})
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>
        {facLicense && environment && (
          <CompliancePage
            merchantId={`blu-${shop.companyId}-${shop.id}`}
            facility={{
              environment: environment,
              facLicense: facLicense,
              userApiKey: employee.userApiKey,
            }}
          />
        )}
      </Grid>
    </Drawer>
  )
}



// WEBPACK FOOTER //
// ./src/components/Metrc/MetrcEmployeeDrawer.tsx